import { NgModule } from '@angular/core';

// TODO: implement different preloading strategies e.g. as with router lazy loading

@NgModule({})
export class CommonLazyLoadingModule {}
